/**
 * @file   聊天对话框
 * @create macaiqi 2025/04/30
 * @update
 */

export default function TalkShade({ img, setShow, className, style }) {
  return (
    <div className="shade animate__animated animate__fadeIn animate__fast">
      <i
        className="close"
        onClick={() => {
          setShow('zqf');
        }}></i>
      <img src={img} alt="" className={className} style={style} />

    </div>
  );
}
